import axios from "axios";
import React, { Component } from "react";
import swal from "sweetalert";
import { baseURL} from "../../../../constants/applicationConstants.js";
import { Loader } from "../../../common/loader/loader.jsx";
import DashBoardJsx from "./dashBoard.jsx";

export class DashBoardclass extends Component {

  constructor(props) {
    super(props);
    this.state = {
      blogData: null,
      expertData: null,
      isProcessing: false,
      offerData: null,
      expertNames: '',
      page: 1,
      expage: 1,
    }
  }
  onScrollerChange = (data) => {    
    let token = JSON.parse(localStorage.getItem('token'));
    let instituteId = JSON.parse(localStorage.getItem("masterID"));
    this.setState({ isLoading: true })

    const payload = {
      "isActive": !data.isActive
    }

    axios.put(`${baseURL}/institute/${instituteId}/instituteOffer/${data.instituteOfferId}`, payload, {
      headers: { 'x-access-token': token }
    }).then(res => {
      this.setState({
        isLoading: false
      })
      this.getBlogData();
    }).catch(err => {
      this.setState({
        isLoading: false
      })
    })
  }
  onEditButtonClickSimple = (data) => {
    // Store the edit data in localStorage for the MyOffer component to pick up
    localStorage.setItem('editOfferData', JSON.stringify({
      ...data,
      editMode: true
    }));
    
    // Navigate to offer page
    this.props.history.push("/myWorkspace?page=myOffer");
  }
  deleteOffer = (data) => {
    let token = JSON.parse(localStorage.getItem('token'));
    this.setState({ isLoading: true })

    axios.delete(`${baseURL}/instituteOffer/${data.instituteOfferId}`, {
      headers: { 'x-access-token': token }
    }).then(res => {
      this.setState({
        isLoading: false
      })
      this.getADS();
    }).catch(err=>{
      this.setState({ isLoading: false })
    })
  }
  onDeleteButtonClick = (data) => {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this Ad",
      icon: "warning",
      buttons: [
        'Do not cancel it!',
        'Yes, Delete it!'
      ],
      dangerMode: true,
    }).then(isConfirm => {
      if (isConfirm) {
        this.deleteOffer(data)
      } else {
        //   swal("Cancelled", "Your imaginary file is safe :)", "error");
      }
    })
  }
  onPaginationButtonClick = (page) => {
    this.setState({ page: page }, () => this.getBlogData(),)
  }

  onPaginationExButtonClick = (expage) => {
    this.setState({ expage: expage }, () => this.getExpertsProductData(),)
  }

  componentDidMount = async () => {
    await this.getExpertData();
    await this.getBlogData();
    // await this.getExpertsProductData();

  }
  getBlogData = () => {
    this.setState({ isProcessing: true })
    const name = JSON.parse(localStorage.getItem("masterID"));
    const token = JSON.parse(localStorage.getItem('token'));
    axios.get(`${baseURL}/articles?page=${this.state.page}&limit=8&expertid=${name}`,
      {
        headers: { 'x-access-token': token }
      }).then(res => {
        this.setState({ blogData: res.data.data.body, isProcessing: false });
      }).catch(err => {
        this.setState({ isProcessing: false })
      })

    if (!token) {
      this.props.history.push("/");
    }

    axios.get(`${baseURL}/institute/${name}/offers`, {
      headers: { 'x-access-token': token }
    }).then(res => {
      this.setState({ offerData: res.data.data })
    }).catch(err => {
      this.setState({ isProcessing: false })
    })
  }

  getExpertsProductData = () => {

    // const name11 = localStorage.getItem("slugSet");
    const name11 = this.state.expertNames;
    const token = JSON.parse(localStorage.getItem('token'));
    
    if(name11)
    {
      axios.get(`${baseURL}/articles?page=${this.state.expage}&limit=8&expertid=${name11}`,
        {
          headers: { 'x-access-token': token }
        }).then(res => {
          this.setState({ expertData: res.data.data.body, isProcessing: false });
        }).catch(err => {
          this.setState({ isProcessing: false })
        })
    }


    if (!token) {
      this.props.history.push("/");
    }
  }

  getExpertData = () => {
    this.setState({ isProcessing: true });
    let token = JSON.parse(localStorage.getItem('token'));
    let instituteId = JSON.parse(localStorage.getItem("masterID"));

    axios.get(`${baseURL}/institute/${instituteId}/experts`, {
      headers: { 'x-access-token': token }
    }).then(res => {
      this.setState({ expertData: res.data.data })
      this.getInstitutionName()

    }).catch(err => {
      this.setState({ isProcessing: false })
    })
  }


  getInstitutionName = () => {
    const tempArr = this.state.expertData?.map(cat => cat?.slugUrl) || [];
    const namesExpert = tempArr.join()
    localStorage.setItem("slugSet",namesExpert );
    this.setState({ expertNames: namesExpert }, function() {
      this.getExpertsProductData();
    })
    
  }



  render() {
    return (
      <div>
        <DashBoardJsx
          blogData={this.state.blogData}
          expertData={this.state.expertData}
          offerData={this.state.offerData}
          onPaginationButtonClick={this.onPaginationButtonClick}
          onPaginationExButtonClick={this.onPaginationExButtonClick}
          onScrollerChange={this.onScrollerChange}
          onEditButtonClick={this.onEditButtonClickSimple}
          onDeleteButtonClick={this.onDeleteButtonClick}
        />
        {this.state.isProcessing && <Loader />}
      </div>
    );
  }
}

export default DashBoardclass;
